import { Theme } from '@radix-ui/themes'

import React from 'react'
import { FaStar as StarIcon } from '@react-icons/all-files/fa/FaStar'
import Modal from 'react-modal'
import { Checkbox, Flex, Text } from 'components/ds'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import modalStyles from 'components/utils/modalStyles'
export type Props = {
  onConfirm: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
  onHideWarningChange: (...args: Array<any>) => any
  hideWarning: boolean
  type: string
  multipleItems?: boolean
}

const InboxRemovalDialog = (props: Props): React.ReactNode => {
  const {
    onConfirm,
    onCancel,
    hideWarning,
    onHideWarningChange,
    multipleItems,
    type,
  } = props
  const dialogMessage = multipleItems ? (
    <p>
      Some of these {type}s haven&#39;t been added to your DISCO yet. Removing
      them from your inbox will also delete them from your DISCO.
    </p>
  ) : (
    <p>
      You haven&#39;t added this {type} to your DISCO yet. Removing this {type}{' '}
      from your inbox will also delete it from your DISCO. Use the <StarIcon />{' '}
      to add to your DISCO.
    </p>
  )
  return (
    <Modal style={modalStyles} isOpen onRequestClose={onCancel}>
      <Theme>
        <div className="Dialog">
          <div>{dialogMessage}</div>
          <Flex gap="2" align="center" justify="between">
            <Text as="label" size="2">
              <Flex gap="2">
                <Checkbox
                  defaultChecked={hideWarning}
                  onCheckedChange={onHideWarningChange}
                />
                Don&#39;t show this warning again
              </Flex>
            </Text>
            <ButtonContainer>
              <Button caption="Cancel" onClick={onCancel} />
              <Button
                caption="Delete"
                onClick={onConfirm}
                appearance="primary"
              />
            </ButtonContainer>
          </Flex>
        </div>
      </Theme>
    </Modal>
  )
}

export default InboxRemovalDialog
